import { StateSelection, StateTransform } from 'molstar/lib/mol-state';
import { StructureElement } from 'molstar/lib/mol-model/structure/structure';
import { StateTransforms } from 'molstar/lib/mol-plugin-state/transforms';
import { PluginCommands } from 'molstar/lib/mol-plugin/commands';
import { arraySetAdd } from 'molstar/lib/mol-util/array';

import {DistanceRepresentationMod} from './customVisualization'
import { DistanceParams } from 'molstar/lib/mol-repr/shape/loci/distance';
import { Task } from 'molstar/lib/mol-task';
import { StateTransformer } from 'molstar/lib/mol-state';
import { PluginStateTransform, PluginStateObject as SO } from 'molstar/lib/mol-plugin-state/objects';
import { getDistanceDataFromStructureSelections } from 'molstar/lib/mol-plugin-state/transforms/helpers';

const MeasurementGroupTag = 'measurement-group';

function getGroup(tags) {
    const state = window.molstar.state.data;
    const groupRef = StateSelection.findTagInSubtree(state.tree, StateTransform.RootRef, MeasurementGroupTag);
    const builder = window.molstar.state.data.build();
    if (groupRef)
        return builder.to(groupRef);
    return builder.toRoot().group(StateTransforms.Misc.CreateGroup, { label: `Measurements` }, { tags: tags });
}

export async function addCustomInteraction(a, b, options) {
    const cellA = window.molstar.helpers.substructureParent.get(a.structure);
    const cellB = window.molstar.helpers.substructureParent.get(b.structure);
    if (!cellA || !cellB)
        return;
    const dependsOn = [cellA.transform.ref];
    arraySetAdd(dependsOn, cellB.transform.ref);
    const update = getGroup(options.tags);
    update
        .apply(StateTransforms.Model.MultiStructureSelectionFromExpression, {
            selections: [
                { key: 'a', groupId: 'a', ref: cellA.transform.ref, expression: StructureElement.Loci.toExpression(a) },
                { key: 'b', groupId: 'b', ref: cellB.transform.ref, expression: StructureElement.Loci.toExpression(b) }
            ],
            isTransitive: true,
            label: 'Distance ' + options.tags
        }, { dependsOn, tags: options === null || options === void 0 ? void 0 : options.selectionTags })
        .apply(StructureSelectionsDistance3DCocomaps, {
            // PER TUTTI I PARAMETRI GUARDARE QUI DistanceParams
            customText: (options === null || options === void 0 ? void 0 : options.customText) || '', // testo inserito al centro della distanza            
            unitLabel: 'Å',
            //textColor: Color(0x6770343), -> Colore del testo della distanza
            textSize: 1,
            linesColor:  options.color, 
            tag: options.tags,
            offsetX: 1.5,
            ...options === null || options === void 0 ? void 0 : options.lineParams,
            ...options === null || options === void 0 ? void 0 : options.labelParams,
            ...options === null || options === void 0 ? void 0 : options.visualParams
        }, { tags: options === null || options === void 0 ? void 0 : options.reprTags });
    const state = window.molstar.state.data;
    await PluginCommands.State.Update(window.molstar, { state, tree: update, options: { doNotLogTiming: true } });
}

// setSubtreeVisibility
const StructureSelectionsDistance3DCocomaps = PluginStateTransform.BuiltIn({
    name: 'structure-selections-interactions-3d',
    display: '3D Interactions',
    from: SO.Molecule.Structure.Selections,
    to: SO.Shape.Representation3D,
    params: () => ({
        ...DistanceParams,
    })
})({
    canAutoUpdate({ oldParams, newParams }) {
        return true;
    },
    apply({ a, params }, plugin) {
        return Task.create('dist', async (ctx) => {
            var _a;
            const data = getDistanceDataFromStructureSelections(a.data);
            const repr = DistanceRepresentationMod(
                { webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl, ...plugin.representation.structure.themes }, 
                () => DistanceParams, a.tags[0]);
            await repr.createOrUpdate(params, data).runInContext(ctx);
            return new SO.Shape.Representation3D({ repr, sourceData: data }, { label: `Distance` });
        });
    },
    update({ a, b, oldParams, newParams }, plugin) {
        return Task.create('dist', async (ctx) => {
            const props = { ...b.data.repr.props, ...newParams };
            const data = getDistanceDataFromStructureSelections(a.data);
            await b.data.repr.createOrUpdate(props, data).runInContext(ctx);
            b.data.sourceData = data;
            return StateTransformer.UpdateResult.Updated;
        });
    },
});